.live-sport-scoreboard {
    color: var(--palette-foreground-primary);
    display: flex;
    gap: 16px;
    justify-content: space-between;
}

.live-sport-scoreboard-team {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 200px;
    min-width: 100px;
    width: 25%;

    &__logo {
        aspect-ratio: 1 / 1;
        border-radius: 50%;
        display: block;
        height: 64px;
        margin: 0 auto;
        width: 64px;
    }

    &__name {
        font: use-font("500 12px/16px");
        text-align: center;
    }
}

.live-sport-scoreboard-metadata {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: center;

    &__score {
        font: use-font-secondary("900 30px/1");
        letter-spacing: 7px;
        margin-right: -7px; // to compensate for letter-spacing
    }

    &__details {
        font: use-font-secondary("500 12px/1");
        margin-top: -3px;
    }
}
